import axios from 'axios';

export const GET_CUSTOMERS_URL = '/customers/getCustomersList';
export const GET_CUSTOMERS_EXCEL_URL = '/customers/getCustomersListForExcel';
export const ADD_EDIT_COMMISSION_URL = '/customers/setCustomerCommission';
export const UPDATE_CUSTOMER_DATA_URL = '/customers/updateCustomerData';

export function findCustomers(queryParams, cancellationHandlers) {
  return axios.get(GET_CUSTOMERS_URL, {params: queryParams, ...cancellationHandlers});
}

export function getCustomersFile(queryParams) {
  return axios.get(GET_CUSTOMERS_EXCEL_URL, {params: queryParams});
}

export function addEditCommission(customerID, commission) {
  return axios.post(ADD_EDIT_COMMISSION_URL, {customerID, commission});
}

export function updateCustomerData(data) {
  return axios.post(UPDATE_CUSTOMER_DATA_URL, data);
}

